export default {
  render() {
    return this.$slots.default
  }
}
